<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Planned periods timeline
                    </div>
                    <!--<div class="card-block">-->
                        <!--<div id="timelineChart"></div>-->
                    <!--</div>-->
                    <div class="card-block">
                        <div id="timelineGraph" style="padding: 0 !important; min-height: 150px;" class="col-md-12 col-xs-12"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import { GoogleCharts } from 'google-charts';
import moment from 'moment';
import vis from 'vis';
import 'vis/dist/vis-timeline-graph2d.min.css';

export default {
  name: 'PlannedPeriodTimeline',
  props: ['projectId'],
  data: function () {
    return {
      options: {
        hAxis: {
          minValue: new Date()
        },
        width: 1200
      },
      gChartsLoaded: false,
      hasData: false,
      timeline: null,
      timelineItems: [],
      timelineGroups: [],
      timelineOptions: {
        //                    locale: window.language,
        //                    timeAxis: {scale: 'weekday'},
        orientation: {
          axis: 'top'
        },
        tooltip: {
          followMouse: true,
          overflowMethod: 'cap'
        },
        // subgroupStack: false,
        stack: false,
        stackSubgroups: true
      },
    };
  },
  watch: {
    graphData: function (val) {
      //                this.drawGraph();
      this.drawTimeline();
    }
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('JiraUsers', ['users']),
    ...mapGetters('PlannedVacations', ['plannedVacations']),
    ...mapGetters('UserRates', ['ratesByUser', 'ratesOnDate']),
    ...mapGetters('SpecialBusinessDays', ['specialBusinessDays']),
    graphData: function () {
      if (!this.gChartsLoaded) return;
      const graphData = new GoogleCharts.api.visualization.DataTable();
      // Add columns
      graphData.addColumn({ type: 'string', id: 'Employee' });
      graphData.addColumn({ type: 'string', id: 'Coefficient' });
      graphData.addColumn({ type: 'string', role: 'tooltip' });
      graphData.addColumn({ type: 'date', id: 'Start' });
      graphData.addColumn({ type: 'date', id: 'End' });
      this.hasData = false;
      for (const plannedVacationId in this.plannedVacations) {
        const plannedVacation = this.plannedVacations[plannedVacationId];
        if (plannedVacation.project_id == this.projectId) {
          if (new Date(plannedVacation.ends_at) >= new Date()) {
            this.hasData = true;
            graphData.addRow([this.users[plannedVacation.user_id].displayName,
              plannedVacation.coefficient,
              `From ${plannedVacation.starts_at} to ${plannedVacation.ends_at}`,
              new Date(plannedVacation.starts_at),
              new Date(new Date(plannedVacation.ends_at).setDate(new Date(plannedVacation.ends_at).getDate() + 1))]);// because both start and end dates are inclusive
          }
        }
      }
      return graphData;
    },
  },
  methods: {
    ...mapActions('PlannedVacations', ['LOAD_PLANNED_VACATIONS']),
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    onGoogleChartsLoaded() {
      this.gChartsLoaded = true;
      this.drawGraph;
    },
    drawGraph() {
      const chart = new GoogleCharts.api.visualization.Timeline(document.getElementById('timelineChart'));
      const graphData = this.graphData;
      if (this.hasData) chart.draw(graphData, this.options);
    },
    drawTimeline() {
      const items = [];
      const groups = [];
      const projectsColors = [];
      let itemCounter = 1;
      let subgroup = 1;
      for (const plannedVacationId in this.plannedVacations) {
        const plannedVacation = this.plannedVacations[plannedVacationId];
        if (plannedVacation.project_id == this.projectId) {
          if (new Date(plannedVacation.ends_at) >= new Date()) {
            let days = 0;
            let hours = 0;
            let cost = 0;
            const startDate = new Date(plannedVacation.starts_at);
            const endDate = new Date(plannedVacation.ends_at);
            let group = '';
            let project = '';
            for (const i in groups) {
              if (groups[i].id == plannedVacation.user_id) {
                group = groups[i];
              }
            }
            if (!group) {
              group = {
                id: plannedVacation.user_id,
                content: this.users[plannedVacation.user_id].displayName,
                //                                    subgroupStack: true
              };
              groups.push(group);
            }
            for (const j in projectsColors) {
              if (projectsColors[j].id == plannedVacation.project_id) {
                project = projectsColors[j];
              }
            }
            if (!project) {
              project = {
                id: plannedVacation.project_id,
                color: this.getRandomColor()
              };
              projectsColors.push(project);
            }
            //                            let itemStyle = "border-radius: 0px; background-color: " + project.color + "; color: #FFFFFF; text-align: center;";
            const itemStyle = 'border-radius: 0px; background-color: darkcyan; color: #FFFFFF; text-align: center;';
            while (startDate <= endDate) {
              const workingHours = 0;
              if (moment(startDate).isoWeekday() != 6 && moment(startDate).isoWeekday() != 7) {
                let specialDay = '';
                for (const i in this.specialBusinessDays) {
                  if (this.specialBusinessDays[i].date == moment(startDate).format('YYYY-MM-DD')) {
                    specialDay = this.specialBusinessDays[i];
                  }
                }
                if (specialDay && specialDay.delta_time == 8) {
                  startDate.setDate(startDate.getDate() + 1);
                  continue;
                }
                days++;
                let workingHours = 0;
                if (specialDay) {
                  workingHours = specialDay.delta_time * plannedVacation.coefficient;
                } else {
                  workingHours = 8 * plannedVacation.coefficient;
                }
                hours += workingHours;
                cost += (workingHours * this.ratesOnDate(moment(startDate).format('YYYY-MM-DD'), plannedVacation.user_id));
                items.push({
                  id: itemCounter,
                  subgroup: subgroup,
                  group: group.id,
                  style: itemStyle,
                  content: workingHours.toString(),
                  start: moment(startDate.setHours(0, 0, 0)),
                  end: moment(startDate.setHours(23, 59, 59))
                });
                itemCounter++;
              }
              startDate.setDate(startDate.getDate() + 1);
            }
            for (const item in items) {
              if (items[item].subgroup == subgroup) {
                items[item].title = `Project: ${this.projects[plannedVacation.project_id].name}<br>`
                                                        + `From ${plannedVacation.starts_at} To ${plannedVacation.ends_at}<br>${
                                                          hours}h / ${cost}€`;
              }
            }
            subgroup++;
          }
        }
      }

      $('#timelineGraph').append('<div id="visTimelineChart"></div>');
      if (this.timeline) {
        this.timeline.destroy();
      }
      const container = document.getElementById('visTimelineChart');
      if (!container) {
        this.drawTimeline();
      }

      this.timeline = new vis.Timeline(container, items, groups, this.timelineOptions);
    }
  },
  mounted() {
    const _this = this;
    if (!window.googleChartsLoaded) {
      window.addEventListener('google-charts-loaded', () => {
        _this.onGoogleChartsLoaded();
      });
    } else this.onGoogleChartsLoaded();
  },
};
</script>
<style>
    /*.vis-panel {*/
        /*box-sizing: content-box;*/
    /*}*/
    /*.vis-background {*/
        /*background-color: #232822;*/
    /*}*/

    /*.vis-time-axis .vis-text{*/
        /*color: white;*/
    /*}*/
    .vis-item {
        height: 20px;
    }
    .vis-item .vis-item-content {
        padding: 0px;
    }
</style>
<style lang="scss" scoped>
    .action {
        margin-left: 5px;
        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }
    /*#chart-wrapper {*/
        /*overflow-x: scroll;*/
        /*overflow-y: hidden;*/
        /*width: 1200px;*/
    /*}*/
</style>
